// extracted by mini-css-extract-plugin
module.exports = {"card-verif":"style_card-verif__3xDlQ"};